import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { codePickersId, CodeCodetablePickerProps } from './types';
import { CodeFieldWireKey } from 'app/area/indicator-factors/types-store';
import { SinglePickerCreator } from 'app/area/indicator-factors/common/single-picker-creator';
import { endpoints } from 'app/area/indicator-factors/item/endpoints';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const SubstanceUom = (props: CodeCodetablePickerProps) => {

  const { breadcrumbs, codeItem, options, translation, validation, readOnly, loadOptions } = props;

  const codetableId = codePickersId.substanceUom;
  const codetableKey = CodeFieldWireKey.substanceUom;

  const substanceKey = CodeFieldWireKey.substance;
  const substanceFetching = options?.substance?.fetching;

  const codeOptions = (options?.[codetableKey]?.codes || []) as CodeComplexValue<number>[];
  const currentValidation = !!validation && !!validation[codetableKey] ? validation[codetableKey] : undefined;
  const finalValidation = {
    ...currentValidation,
    ...getDisabledValidation(codeItem?.[codetableKey]?.disabled, translation.selected_value_disabled)
  };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id, endpoints.substanceUom, {
      ...loadOptionsParams,
      substanceId: codeItem?.substance?.value,
      siblingId: undefined,
      levels: undefined
    });
  };

  const onChange = (value: CodeComplexValue<number>) => {
    props.resetValidation(codetableKey, value);
    props.onChange(codetableKey, value);
    props.clearAllValidation(codetableKey);
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs);

  const isReadOnly = readOnly || (codeItem && !codeItem[substanceKey]) || substanceFetching;

  return <SinglePickerCreator
    id={codetableKey}
    label={translation.substanceUom}
    valueItem={codeItem && codeItem[codetableKey]}
    searchRequired={false}
    required={!readOnly}
    readOnly={isReadOnly}
    minLength={1}
    options={codeOptions}
    fetchingOptions={options?.[codetableKey]?.fetching}
    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    extraFooterButton={extraFooterButton}
    validation={finalValidation}
  />;
};
